import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AcquedottiInputSelectComponent } from 'src/app/modules/acquedotti/components/acquedotti-input-select/acquedotti-input-select.component';
import { WaterSupplyZoneInputSelectComponent } from 'src/app/modules/water-supply-zone/components/wsz-input-select/wsz-input-select.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { InputSelectStringComponent } from "../../input-select-string/input-select-string.component";
import { WaterSupplyZoneService } from 'src/app/modules/water-supply-zone/water-supply-zone.service';
import { AcquedottiService } from 'src/app/modules/acquedotti/acquedotti.service';


@Component({
  selector: 'app-acquedotto-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    WaterSupplyZoneInputSelectComponent,
    AcquedottiInputSelectComponent,
    InputTextComponent,
    InputSelectStringComponent
],
  templateUrl: './acquedotto-form.component.html',
  styleUrl: './acquedotto-form.component.css',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AcquedottoFormComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() model?: any | undefined;
  wsz = this.wszService.query.list;
  acquedotti = this.acquedottiService.query.list;
  wszAll:string[]=[]
  acquedottiAll:string[]=[]
  callBackFunctionWsz = (list:any, currentValue:string) => {
    const filteredList = this.wszService.query.list().filter(dato => typeof dato.codice === 'string' && dato.codice.toLowerCase().includes(currentValue)).map(el => el.codice);
    list.set(filteredList);
  }
  callBackFunctionAcquedotti = (list:any, currentValue:string) => {
    const filteredList = this.acquedottiService.query.list().filter(dato => typeof dato.codice === 'string' && dato.codice.toLowerCase().includes(currentValue)).map(el => el.codice);
    list.set(filteredList);
  }
  constructor(
    @Inject(WaterSupplyZoneService) public wszService: WaterSupplyZoneService,
    @Inject(AcquedottiService) public acquedottiService: AcquedottiService,

  ) {  
      this.getWsz();
      this.getAcquedotti()
      
     }
  
  ngOnInit() {
 
    this.form.addControl('wszId', new FormControl('', []));
    this.form.addControl('acquedottoId', new FormControl('', [Validators.required]));
    this.form.addControl('progressivoLineAcquedottistica', new FormControl('', []));

  }

  getWsz() {
    this.wszService.query.get({ pageable: { size: 99999 }}, ()=>{

     this.wszAll=this.wsz().map(el => el.codice)

    });
    
  }

  getAcquedotti() {
    this.acquedottiService.query.get({ pageable: { size: 99999 }}, ()=>{

     this.acquedottiAll=this.acquedotti().map(el => el.codice)

    });
  }
}
